import useSWR from "swr";
import { useMemo } from "react";

import axios, { fetcher, endpoints } from "src/utils/axios";
import { IAddressItem } from "src/types/address";

export interface FeedbackPayload {
  feature_key?: string;
  reasons: string[];
  comment?: string;
  usefulness?: number;
  context?: {
    path?: string;
    locale?: string;
    ts?: string;
  };
  userId?: number;
}

export async function sendFeedback(data: FeedbackPayload) {
  return axios.post(endpoints.system.feedback, data);
}

export async function sendPublicFeedback(data: FeedbackPayload) {
  return axios.post(endpoints.system.publicfeedback, data);
}
